var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href && _vm.href.length > 0)?_c('a',{class:_vm.badgeClass,attrs:{"href":_vm.href,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":_vm.actualIcon}}),_vm._v("\n   \n  "),_vm._t("default",function(){return [_vm._v("File")]}),_vm._v(" \n  "),_c('font-awesome-icon',{attrs:{"icon":_vm.fileIcon}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }